var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 26C20.8292 26 26.625 20.2042 26.625 13C26.625 5.79579 20.8292 0 13.625 0C6.42079 0 0.625 5.79579 0.625 13C0.625 20.2042 6.42079 26 13.625 26Z",
    fill: "#50AF95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3968 14.4438C15.2979 14.4513 14.7867 14.4821 13.6464 14.4821C12.7394 14.4821 12.0955 14.4546 11.8696 14.4438C8.36458 14.2878 5.7484 13.6708 5.7484 12.9321C5.7484 12.1933 8.36458 11.5771 11.8696 11.4187V13.8292C12.0988 13.8459 12.7551 13.8851 13.6621 13.8851C14.7504 13.8851 15.2954 13.8392 15.3935 13.8301V11.4203C18.8911 11.5779 21.5015 12.195 21.5015 12.9321C21.5015 13.6691 18.8919 14.2862 15.3935 14.4429L15.3968 14.4438ZM15.3968 11.171V9.01396H20.2779V5.72456H6.98847V9.01396H11.8687V11.1702C7.90202 11.3545 4.91895 12.1491 4.91895 13.1013C4.91895 14.0535 7.90202 14.8473 11.8687 15.0324V21.9447H15.396V15.0299C19.3537 14.8457 22.3318 14.0519 22.3318 13.1005C22.3318 12.1491 19.3561 11.3553 15.396 11.1702L15.3968 11.171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.fa1284624e4f798a08c06d017155f826.svg";
export { ForwardRef as ReactComponent };